import React, { useState, useEffect } from 'react'
import { Card, Steps, message } from 'antd'
import { PageHeader } from '@components'
import './style.less'
import ChooseRecordPage from './components/choose-record'
import ChooseQualityCheckPlanPage from './components/choose-quality-check-plan'
import StartQualityCheckTaskPage from './components/start-quality-check-task'
import { createQualityCheckTask } from '@services/ai-quality-check'
import { AIQualityCheckTaskCreateFilter } from 'src/types/ai-quality-check'
import { useParams } from 'react-router-dom'
import { getUrlParam } from '@library'
import { CurrentSteps } from '../quality-check-scheme-detail/constants'

const QualityCheckCreatePage = () => {
  const [current, setCurrent] = useState(0)
  const taskId = +useParams<{ id: string }>()?.id
  const status = Number(getUrlParam('status')) || 0
  const [createId, setCreateId] = useState(null)

  const saveQualityCheckTask = async (data: AIQualityCheckTaskCreateFilter, specialStatus?: number, savedId?: number) => {
    const params = {
      ...data,
      status: typeof specialStatus === 'number' && !isNaN(specialStatus) ? specialStatus : Math.max(status, current + 1),
      ...(savedId ? { taskId: savedId } : (taskId ? { taskId } : {})),
    }
    const [res, err] = await createQualityCheckTask(params)
    if (err) {
      message.error(`保存质检任务失败:${err?.message}`)
      return false
    }
    status === 0 && res?.taskId && setCreateId(res?.taskId)
    return true
  }

  const handleNextStep = async (stepData:AIQualityCheckTaskCreateFilter, specialStatus?: number, savedId?: number) => {
    const result = await saveQualityCheckTask(stepData, specialStatus, savedId)
    result && current < CurrentSteps.STEP_THREE && setCurrent(current + 1)
    result && current === CurrentSteps.STEP_THREE && (window.location.href = '/config/quality-check-management')
  }

  const handleSaveDraft = async (stepData:AIQualityCheckTaskCreateFilter, specialStatus?: number, savedId?: number) => {
    const result = await saveQualityCheckTask(stepData, specialStatus, savedId)
    if (result) window.location.href = '/config/quality-check-management'
  }

  const handleBack = async (stepData:AIQualityCheckTaskCreateFilter, specialStatus?: number, savedId?: number) => {
    const result = await saveQualityCheckTask(stepData, specialStatus, savedId)
    if (result) setCurrent(current - 1)
  }

  useEffect(() => {
    if (status) {
      setCurrent(status - 1)
    }
  }, [])
  return (
    <div className="quality-check-create-page">
      <PageHeader title="创建质检任务" />
      <Card className="mt20 mb20">
        <Steps
          current={current}
          items={[
            {
              title: '选择待检对话数据',
              description: '选择数据类型，设置数据匹配条件',
            },
            {
              title: '选择质检方案',
              description: '选择任务调用的质检方案/规则',
            },
            {
              title: '启用检测',
              description: '检查任务配置，确认是否必须人工复核',
            },
          ]}
        />
      </Card>
      {current === CurrentSteps.STEP_ONE && <ChooseRecordPage onSave={handleSaveDraft} onNextStep={handleNextStep} createId={createId} />}
      {current === CurrentSteps.STEP_TWO && <ChooseQualityCheckPlanPage onSave={handleSaveDraft} onNextStep={handleNextStep} onBack={handleBack} createId={createId} />}
      {current === CurrentSteps.STEP_THREE && <StartQualityCheckTaskPage onSave={handleSaveDraft} onNextStep={handleNextStep} onBack={handleBack} createId={createId} />}
    </div>
  )
}

export default QualityCheckCreatePage
